import { render, staticRenderFns } from "./CustomerPortalFooter.vue?vue&type=template&id=59e85d46&scoped=true&"
import script from "./CustomerPortalFooter.vue?vue&type=script&lang=js&"
export * from "./CustomerPortalFooter.vue?vue&type=script&lang=js&"
import style0 from "./CustomerPortalFooter.vue?vue&type=style&index=0&id=59e85d46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e85d46",
  null
  
)

export default component.exports